import React, { useState } from 'react';
import GeneralSearchStrip from '../../../Elements/GeneralSearchStrip';
import DemoListSearchParams from './DemoListSearchParams';
import { showNotificationPopup } from '../../../Elements/NotificationPopupHost';

// Columns for the columns flyout. ShopId is locked (always visible), like a real
// list's id column; the rest are user-toggleable.
const DEMO_COLUMNS = [
  { key: 'ShopId', label: 'Shop ID', locked: true },
  { key: 'ShopName', label: 'Shop name', locked: false },
  { key: 'City', label: 'City', locked: false },
  { key: 'Status', label: 'Status', locked: false },
  { key: 'IsActive', label: 'Active', locked: false },
];

// Dummy feedback for every toolbar action — same convention as NotificationDemo.
function fireToolbarPopup(title) {
  showNotificationPopup({
    id: 'search-toolbar-demo',
    count: 1,
    title,
    accent: 'info',
    glyph: 'fa-solid fa-sliders',
    ctaLabel: 'OK',
    onView: () => {},
  });
}

function SearchStripDemoComponent() {
  // new X(true) => TRUE defaults, skips loading the URL query into the instance.
  const [searchItem] = useState(() => new DemoListSearchParams(true));
  const [hiddenColumns, setHiddenColumns] = useState(() => new Set());

  const toggleColumn = (key) => {
    setHiddenColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  return (
    <GeneralSearchStrip
      searchItem={searchItem}
      searchParamsType={DemoListSearchParams}
      singleSearchLine={true}
      singleSearchLinePlaceholder='Search shops by id, name, city...'
      resultCount={137}
      enableUrlPush={false}
      isFilterDisabled={false}
      isRefreshDisabled={false}
      isOptionsDisabled={false}
      isExportExcelDisabled={false}
      useClickOnClearAll={true}
      columns={DEMO_COLUMNS}
      hiddenColumns={hiddenColumns}
      onToggleColumn={toggleColumn}
      onResetColumns={() => setHiddenColumns(new Set())}
      clickOnOk={() => fireToolbarPopup('Search applied (dummy)')}
      clickOnRefresh={() => fireToolbarPopup('Refreshed (dummy)')}
      clickOnCancel={() => {}}
      clickOnClearAll={() => fireToolbarPopup('Filters cleared (dummy)')}
      clickOnExportExcel={() => fireToolbarPopup('Excel export started (dummy)')}
    />
  );
}

export const searchStripDemo = {
  id: 'search-toolbar',
  title: 'Search toolbar (GeneralSearchStrip)',
  category: 'Lists & Grids',
  importPath: 'Elements/GeneralSearchStrip',
  notes: [
    'The toolbar TabOfDataTable renders above every list — search line, count pill, Filters + panel, Export Excel, Refresh, Clear-All, Columns flyout, Settings. Use directly only on custom (non-TabOfDataTable) lists.',
    'The isXDisabled flags gate which buttons appear/enable: isFilterDisabled, isRefreshDisabled, isOptionsDisabled (Settings), isExportExcelDisabled. This demo enables all of them.',
    'singleSearchLine={true} activates the quick-search input; it debounces and calls clickOnOk(ShownPanelsEnum.Search, item) 1.5s after typing stops.',
    'Filters opens the real GeneralSearchPanelFigma from searchParamsType.fieldsInSearchBox; the badge counts fields differing from new searchParamsType(true).',
    'columns ({ key, label, locked }) + hiddenColumns (a Set) drive the Columns flyout via onToggleColumn/onResetColumns; locked columns can’t be hidden.',
    'enableUrlPush={false} here so the filter panel doesn’t clobber the gallery’s ?entry= URL; real pages leave it on for shareable filter URLs.',
    'Note: the Settings (gear) button also fires clickOnRefresh in the current component wiring.',
  ],
  snippet:
    "<GeneralSearchStrip\n  searchItem={this.state.searchItem}\n  searchParamsType={MySearchParams}\n  singleSearchLine={true}\n  resultCount={total}\n  isFilterDisabled={false}\n  isRefreshDisabled={false}\n  clickOnOk={this.startSearch}\n  clickOnRefresh={this.refresh}\n/>",
  render: SearchStripDemoComponent,
};
